import Container from '../../atoms/container/parentalPinDialContainer';
import Focus from '../../../../shared/types/enums/focus';
import ListContext from '../../../../shared/components/utils/context/listContext';
import ParentalPinDialDown from './parentalPinDialDown';
import ParentalPinDialUp from './parentalPinDialUp';
import useKeyboard from '../../../../shared/components/utils/hooks/useKeyboard';
import { ParentalPinDialProps as Props } from '../../../../shared/types/props/parentalPin';
import { useContext, useEffect, useRef, useState } from 'react';

function ParentalPinDial({ callback, index }: Props) {
  const { listIndex } = useContext(ListContext);
  const [dial, setDial] = useState(0);
  const focusedRef = useRef(false);
  focusedRef.current = index === listIndex;

  useEffect(() => {
    callback(dial);
  }, [dial]);

  useKeyboard({
    focus: Focus.MODAL_INPUT,
    keyDownHandler: (key) => {
      if (!focusedRef.current) return;
      switch (key) {
        case 'DOWN':
          setDial((dial) => (((dial - 1) % 10) + 10) % 10);
          break;
        case 'UP':
          setDial((dial) => (dial + 1) % 10);
          break;
      }
    },
  });

  return (
    <>
      <Container focused={focusedRef.current}>
        {focusedRef.current ? <ParentalPinDialUp /> : null}
        {dial}
        {focusedRef.current ? <ParentalPinDialDown /> : null}
      </Container>
    </>
  );
}

export default ParentalPinDial;
